import { render, staticRenderFns } from "./prizeDrawEdit.vue?vue&type=template&id=64ed485e&scoped=true&"
import script from "./prizeDrawEdit.vue?vue&type=script&lang=ts&"
export * from "./prizeDrawEdit.vue?vue&type=script&lang=ts&"
import style0 from "./prizeDrawEdit.vue?vue&type=style&index=0&id=64ed485e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed485e",
  null
  
)

export default component.exports